import { Routes, Route, Navigate } from 'react-router-dom'
import AuthProvider, { useAuth } from './contexts/AuthProvider'
import MobileLayout from './components/MobileLayout'
import LoginPage from './pages/LoginPage'
import HomePage from './pages/HomePage'
import TrainingPage from './pages/TrainingPage'
import CheckInPage from './pages/CheckInPage'
import AttendancePage from './pages/AttendancePage'
import LeaveRequestPage from './pages/LeaveRequestPage'
import BookingsPage from './pages/BookingsPage'
import MorePage from './pages/MorePage'
import DocumentsPage from './pages/DocumentsPage'
import PoliciesPage from './pages/PoliciesPage'
import ProfileEditPage from './pages/ProfileEditPage'
import { Loader2 } from 'lucide-react'

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader2 className="h-6 w-6 animate-spin text-emerald-500" />
      </div>
    )
  }

  if (!user) return <Navigate to="/login" replace />
  return children
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader2 className="h-6 w-6 animate-spin text-emerald-500" />
      </div>
    )
  }

  if (user) return <Navigate to="/" replace />
  return children
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          }
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MobileLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<HomePage />} />
          <Route path="training" element={<TrainingPage />} />
          <Route path="checkin" element={<CheckInPage />} />
          <Route path="attendance" element={<AttendancePage />} />
          <Route path="attendance/request" element={<LeaveRequestPage />} />
          <Route path="bookings" element={<BookingsPage />} />
          <Route path="more" element={<MorePage />} />
          <Route path="more/documents" element={<DocumentsPage />} />
          <Route path="more/policies" element={<PoliciesPage />} />
          <Route path="more/profile" element={<ProfileEditPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  )
}
